// eslint-disable-next-line import/no-cycle
import config from '../../config'
// eslint-disable-next-line import/no-cycle
import { getUserInfo } from './common-user-info'

// eslint-disable-next-line import/no-cycle
export { getUserInfo, removeUserInfo } from './common-user-info'

export function getPermission() {
  const userInfo = getUserInfo()

  return userInfo && userInfo.permissions && Number.isInteger(userInfo.currentPermissionIndex)
    ? userInfo.permissions[userInfo.currentPermissionIndex]
    : null
}

export function setUserInfo(nextProps, isBackofficeWebsite) {
  const userInfoKey = isBackofficeWebsite
    ? 'BACKOFFICE_' + config.USER_INFO_KEY
    : config.USER_INFO_KEY

  // Prepare current UserInfo or create a new one (with default props) for merge
  const props = getUserInfo(userInfoKey) || { currentPermissionIndex: 0 }

  window.localStorage.setItem(userInfoKey, JSON.stringify({ ...props, ...nextProps }))

  return getUserInfo()
}
